var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 0H7.2C5.88 0 4.8 1.08 4.8 2.4V20.4C4.8 21.12 4.2 21.6 3.6 21.6C3 21.6 2.4 21.12 2.4 20.4V7.2C2.4 6.6 1.8 6 1.2 6C0.6 6 0 6.6 0 7.2V21.6C0 22.92 1.08 24 2.4 24H21.6C22.92 24 24 22.92 24 21.6V2.4C24 1.08 22.92 0 21.6 0ZM15.6 12H8.4C7.8 12 7.2 11.52 7.2 10.8C7.2 10.2 7.8 9.6 8.4 9.6H15.6C16.2 9.6 16.8 10.2 16.8 10.8C16.8 11.52 16.2 12 15.6 12ZM20.4 7.2H8.4C7.8 7.2 7.2 6.72 7.2 6C7.2 5.4 7.8 4.8 8.4 4.8H20.4C21 4.8 21.6 5.4 21.6 6C21.6 6.72 21 7.2 20.4 7.2Z",
    fill: "#473F68"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.de97f213b0594822b175751f64bc7f59.svg";
export { ForwardRef as ReactComponent };